export enum ACTION {
  TRADE_AGREEMENTS_READ = "trade_agreements_read",
  TRADE_AGREEMENTS_EDIT = "trade_agreements_edit",
}
